module.exports = __webpack_public_path__ + "static/media/icon-qr.97e9e373.svg";